(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sim-phone', {
            /*
            parent: 'entity',
            url: '/sim-phone?page&sort&search',
            */
            parent: 'dictionary',
            url: '/sim-phone?page&sort&search&actualFilter',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.simPhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sim-phone/sim-phones.html',
                    controller: 'SimPhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'number,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('simPhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sim-phone-detail', {
            parent: 'sim-phone',
            url: '/sim-phone/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.simPhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sim-phone/sim-phone-detail.html',
                    controller: 'SimPhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('simPhone');
                    // additional translations
                    $translatePartialLoader.addPart('employee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SimPhone', function($stateParams, SimPhone) {
                    return SimPhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sim-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sim-phone-detail.edit', {
            parent: 'sim-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-dialog.html',
                    controller: 'SimPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SimPhone', function(SimPhone) {
                            return SimPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sim-phone.new', {
            parent: 'sim-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-dialog.html',
                    controller: 'SimPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sim-phone', null, { reload: 'sim-phone' });
                }, function() {
                    $state.go('sim-phone');
                });
            }]
        })
        .state('sim-phone.edit', {
            parent: 'sim-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-dialog.html',
                    controller: 'SimPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SimPhone', function(SimPhone) {
                            return SimPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sim-phone', null, { reload: 'sim-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sim-phone.delete', {
            parent: 'sim-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sim-phone/sim-phone-delete-dialog.html',
                    controller: 'SimPhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SimPhone', function(SimPhone) {
                            return SimPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sim-phone', null, { reload: 'sim-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
